/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './unmuteActor.defs.js'
export { main as default } from './unmuteActor.defs.js'
